<template>
	<div>
		<component
			v-if="currentView"
			:is="currentView"
			:form-data="formData"
			:wizard-deps="wizardDependencies"
			:step-deps="currentStepDeps"
			:loading="loading"
			@update="onUpdate"
		/>
	</div>
</template>

<script>
import ViewResolver from '../../services/ViewResolver'

/**
 * Bis auf den letzten Step benötigt serverseitige Validierung Step-Key in Url.
 * Validierung im letzten Step (mit/ohne Step-Key) muss vollständige Validierung auslösen.
 *
 */
export default {
	props: {
		steps: {
			type: Array,
			required: true
		},
		dataUrl: {
			type: String,
			required: false
		}
	},

	data() {
		return {
			index: 0,

			// global (einmal pro Wizard)
			wizardDependencies: {},

			// step-spezifisch (cached)
			stepDependencies: {},

			// User Input (persistiert über Steps)
			formData: null,
			validationErrors: null,

			currentView: null,
			loading: false
		}
	},

	computed: {
		currentStep() {
			return this.steps[this.index]
		},
		currentStepDeps() {
			return this.stepDependencies[this.currentStep?.key] || {}
		}
	},

	async created() {
		// 1. Wizard Dependencies laden (optional)
		if (this.dataUrl) {
			this.wizardDependencies = await ViewResolver.resolveData(this.dataUrl)
		}

		if(this.formData === null && this.wizardDependencies.defaults){
			this.formData = this.wizardDependencies.defaults;
		}


		// 2. Ersten Step laden
		await this.resolveStep()

		this.$bus.$on('wizard:back', this.back)
		this.$bus.$on('wizard:next', this.next)
	},

	beforeDestroy() {
		this.$bus.$off('wizard:back', this.back)
		this.$bus.$off('wizard:next', this.next)
	},

	methods: {
		async resolveStep() {
			const step = this.currentStep
			this.loading = true

			// View laden
			this.currentView = await ViewResolver.resolveView(step.view)

			// Step Dependencies nur einmal laden
			if (!this.stepDependencies[step.key]) {
				this.$set(
					this.stepDependencies,
					step.key,
					await ViewResolver.resolveData(step.dataUrl, step.data, step.key)
				)
			}

			this.loading = false

			if (this.validationErrors) {
				this.$nextTick(() => {
					this.$bus.$emit('form:invalid', this.validationErrors)
				})

				// optional: nur einmal anzeigen
				// this.validationErrors = null
			}
		},
		onUpdate(updated) {
			this.formData = { ...this.formData, ...updated }
		},
		async back(errors) {
			if (errors) {
				this.validationErrors = errors
			}

			if (this.index === 0) return
			this.index--
			await this.resolveStep()
		},
		async next() {
			if (this.index >= this.steps.length - 1) return
			this.index++
			await this.resolveStep()
		}
	}
}
</script>
